export default {
  pageSize: null,
  currentPage: 1,
  totalPages: null,
  totalRecords: null,
  visibleRecords: null,
};
